import React from 'react'
import { Classes, Text } from '@blueprintjs/core'
import Widget from '../../components/Widget'
import { UprightStyle } from '../../types'

const styles: UprightStyle = {
  widget: { display: 'grid', gridColumn: '1fr' },
  generalSettingsContainer: { padding: 10 },
  versionContainer: { display: 'flex', justifyContent: 'center' }
}

// There is no way to navigate to this page unless they know they exact URL
export default () => (
  <Widget title="Dark Mode" style={styles.widget}>
    <div style={styles.generalSettingsContainer}>
      <label className="bp5-control bp5-switch">
        <input type="checkbox" checked={false} onChange={() => {}} />
        <span className="bp5-control-indicator" />
        Dark Mode <span className={Classes.TEXT_MUTED}>coming soon!</span>
      </label>
      <div>
        <hr />
      </div>
    </div>
    <div style={styles.versionContainer}>
      <Text className={Classes.TEXT_MUTED}>Client version: {import.meta.env.VITE_SOURCE_VERSION}</Text>
    </div>
  </Widget>
)
